"use client";

import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useState } from "react";
import { Link } from "@/components/common/Link";
export default function PlatosEmblematicos() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const dishes = [{
    name: "Tacos de Cochinita Pibil",
    description: "Cochinita pibil: cerdo asado lentamente con adobo de achiote y cebolla encurtida",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/tacos_cochinita_pibil.png"
  }, {
    name: "Ceviche del Caribe",
    description: "Ceviche caribeño: frescura del pescado local con lima, cilantro y frutas tropicales",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/ceviche_del_caribe.png"
  }, {
    name: "Mole Negro Oaxaqueño",
    description: "Mole negro oaxaqueño: mole de chocolate y chile con pollo de herencia tradicional",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/mole_negro_oaxaqueno.png"
  }, {
    name: "Pesca del Día a la Parrilla",
    description: "Pescado del día a la parrilla con glaze de chipotle y cítricos",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/pesca_dia_parrilla.png"
  }];
  return <section id="platos-emblemáticos" ref={sectionRef} className="relative bg-muted py-32 md:py-40 overflow-hidden">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className={`text-center mb-16 md:mb-20 transition-all duration-[var(--duration-medium)] ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-medium text-foreground mb-6">
            Platos Emblemáticos
          </h2>
          <div className="w-24 h-px bg-accent mx-auto mb-8" />
          <p className="font-sans font-light text-muted-foreground text-lg md:text-xl max-w-2xl mx-auto">
            Descubre platos que combinan la tradición mexicana con técnicas contemporáneas
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          {dishes.map((dish, i) => <Card key={i} data-index={i} onMouseEnter={() => setHoveredIndex(i)} onMouseLeave={() => setHoveredIndex(null)} className={`group relative overflow-hidden bg-white cursor-pointer p-0 rounded-2xl transition-all duration-300 ease-[var(--ease-smooth)] border-none ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"} ${hoveredIndex === i ? "shadow-strong -translate-y-2" : "shadow-soft"}`} style={{
          transitionDelay: sectionVisible ? `${i * 80}ms` : "0ms"
        }}>
              <div className="relative aspect-[3/4] overflow-hidden">
                <img src={dish.image} alt={dish.name} className={`w-full h-full object-cover transition-transform duration-300 ease-[var(--ease-smooth)] ${hoveredIndex === i ? "scale-103" : "scale-100"}`} />
                
                <div className={`absolute inset-0 bg-black/60 backdrop-blur-[2px] p-8 flex flex-col justify-end transition-all duration-300 ease-[var(--ease-smooth)] ${hoveredIndex === i ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
                  <div className={`transition-all duration-500 delay-75 transform ${hoveredIndex === i ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
                    <h3 className="font-display font-medium text-2xl mb-4 text-white leading-tight">
                      {dish.name}
                    </h3>
                    <p className="font-sans font-light text-sm text-white/90 leading-relaxed mb-8">
                      {dish.description}
                    </p>
                    <Link to="#menu" className="inline-block border border-white text-white px-6 py-2.5 rounded-md font-medium text-sm hover:bg-primary hover:border-primary transition-all duration-300 text-center w-full">
                      Ver en menú
                    </Link>
                  </div>
                </div>

                <div className={`absolute inset-x-0 bottom-0 bg-primary/90 text-white p-6 transition-all duration-300 ease-[var(--ease-smooth)] ${hoveredIndex === i ? "opacity-0 translate-y-full" : "opacity-100 translate-y-0"}`}>
                  <h3 className="font-display font-medium text-lg leading-tight">
                    {dish.name}
                  </h3>
                </div>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}